const STREAM_IN_LIMIT = 100;
const STREAM_PAGE_LIMIT = 30;

function timestamp(value) {
  if (!value) {
    return 0;
  }
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
}

export function compareChannels(a, b) {
  const pinnedA = timestamp(a.state?.membership?.pinned_at);
  const pinnedB = timestamp(b.state?.membership?.pinned_at);
  if (pinnedA !== pinnedB) {
    return pinnedB - pinnedA;
  }
  const lastA = timestamp(a.state?.last_message_at || a.data?.last_message_at);
  const lastB = timestamp(b.state?.last_message_at || b.data?.last_message_at);
  return lastB - lastA;
}

export async function queryChannelsByIds(client, { channelIds, memberId }) {
  if (!channelIds?.length) {
    return [];
  }

  const channels = [];
  const seen = new Set();
  const sort = [{ pinned_at: -1 }, { last_message_at: -1 }];

  for (let index = 0; index < channelIds.length; index += STREAM_IN_LIMIT) {
    const ids = channelIds.slice(index, index + STREAM_IN_LIMIT);
    let offset = 0;

    while (offset < ids.length) {
      const page = await client.queryChannels(
        {
          type: "messaging",
          members: { $in: [String(memberId)] },
          id: { $in: ids },
        },
        sort,
        { limit: STREAM_PAGE_LIMIT, offset, state: true, watch: true }
      );

      let added = 0;
      for (const channel of page) {
        if (!seen.has(channel.cid)) {
          seen.add(channel.cid);
          channels.push(channel);
          added += 1;
        }
      }

      if (!page.length || added === 0 || page.length < STREAM_PAGE_LIMIT) {
        break;
      }
      offset += page.length;
    }
  }

  channels.sort(compareChannels);
  return channels;
}

export const FILTERED_CHANNEL_PAGE_SIZE = 30;
